import React, { useEffect } from 'react';

import { MtxButton, MtxGrid } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import CardContact from '@/components/CardContact/CardContact';
import { GoBackArrowBtn } from '@/components/GoBackArrowBtn/GoBackArrowBtn';
import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';
import useScreenSize from '@/hooks/useScreenSize';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import { useUserStore } from '@/store/useStore';

import styles from './styles.module.css';

export const HelpPage: React.FC = () => {
  const { windowWidth } = useScreenSize();
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const userConseiller = useUserStore((state) => state.user);
  const handlePhoneCall = () => {
    document.location.href = 'tel:+330147203300';
  };

  if (sessionStorage.parcoursVersementData) {
    sessionStorage.removeItem('parcoursVersementData');
  }

  useEffect(() => {
    TRACKING_INSTANCE.setTcVars({
      page_nom: 'besoin d aide',
      page_template: 'espace client',
      user_id: user?.id,
      user_client: user?.type === 'Client',
      user_connexion: user?.success,
      user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
    });
    void TRACKING_INSTANCE.triggerEvent('page', undefined, {
      event_id: 'page',
      event_categorie: 'affichage espace client',
      event_nom: 'besoin d aide',
      event_page: 'besoin d aide',
    });
  }, [user]);

  return (
    <MtxGrid className={styles.boxHelpPage} fullWidth row>
      <MtxGrid className={styles.helpPageHead} col={12} offset={0}>
        {windowWidth < 900 && <GoBackArrowBtn />}

        <h1 className={styles.helpTitle}>{t('helpInfo.label')}</h1>
        <span className={styles.helpDescription}>{t('helpInfo.description')}</span>
      </MtxGrid>

      <MtxGrid className={styles.helpPageCardContainer} row>
        <MtxGrid className={styles.helpPageCard} col={4} colXs={12} colSm={6} colMd={6} colLg={4} colXl={4}>
          <CardContact
            backgroundTitre="TEXT_CHAT_DISPONIBLE"
            buttonChat={
              <>
                <MtxButton
                  className="card-button-chat-indisponible"
                  size="medium"
                  full-width="true"
                  onClick={() => {}}
                  disabled
                >
                  <div className={styles.textButtonHelp}>{t('helpInfo.chatWithAdvisorLabel')}</div>
                </MtxButton>
                <MtxButton
                  className="card-button-chat-disponible"
                  style={{ display: 'none' }}
                  size="medium"
                  full-width="true"
                  onClick={() => {
                    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                      event_id: 'clic',
                      event_categorie: 'clic',
                      event_metier: 'espace client placement',
                      event_nom: 'echanger avec un conseiller',
                      event_detail_1: 'cta',
                    });
                  }}
                  disabled={userConseiller?.advisorView === true}
                >
                  <div className={styles.textButtonHelp}>{t('helpInfo.chatWithAdvisorLabel')}</div>
                </MtxButton>
              </>
            }
            descriptionSection="DESCRIPTION_MIDDLE_CHAT"
            icon="ICON_CHAT"
            textIcon="TITRE_CHAT"
            textDescription={
              <>
                <div className="card-text-disponible" style={{ display: 'none' }}>
                  {t('helpInfo.wording')}
                </div>
                <div className="card-text-indisponible">{t('helpInfo.chatUnavailableMessage')}</div>
              </>
            }
          />
        </MtxGrid>

        <MtxGrid className={styles.helpPageCard} col={4} colXs={12} colSm={6} colMd={6} colLg={4} colXl={4}>
          <CardContact
            backgroundTitre="TEXT_CHAT_DISPONIBLE"
            buttonChat={
              <MtxButton
                size="medium"
                full-width="true"
                onClick={() => {
                  navigate(ROUTE.RAPPELCONSEILLER);
                  void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                    event_id: 'clic',
                    event_categorie: 'clic',
                    event_metier: 'espace client placement',
                    event_nom: 'etre rappele par un conseiller',
                    event_detail_1: 'cta',
                  });
                }}
                disabled={userConseiller?.advisorView === true}
              >
                <div className={styles.textButtonHelp}>{t('helpInfo.callbackRequestLabel')}</div>
              </MtxButton>
            }
            descriptionSection="DESCRIPTION_MIDDLE_CHAT"
            icon="ICON_RAPPEL_CONSEILLER"
            textIcon="TITRE_ETRE_APPELER"
            textDescription={<>{t('helpInfo.callbackDescription')}</>}
          />
        </MtxGrid>

        <MtxGrid className={styles.helpPageCard} col={4} colXs={12} colSm={6} colMd={6} colLg={4} colXl={4}>
          <CardContact
            backgroundTitre="TEXT_CHAT_DISPONIBLE"
            buttonChat={
              <MtxButton
                size="medium"
                full-width="true"
                onClick={() => {
                  handlePhoneCall();
                  void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                    event_id: 'clic',
                    event_categorie: 'clic',
                    event_metier: 'espace client placement',
                    event_nom: 'joindre un conseilller',
                    event_detail_1: 'cta',
                  });
                }}
                disabled={userConseiller?.advisorView === true}
              >
                <div className={styles.textButtonHelp}>{t('helpInfo.contactAdvisorLabel')}</div>
              </MtxButton>
            }
            descriptionSection="DESCRIPTION_MIDDLE_CHAT"
            icon="ICON_RAPELLER_CONSEILLER"
            textIcon="TITRE_APPELER_CONSEILLER"
            textDescription={<>{t('helpInfo.phoneAvailabilityMessage')}</>}
          />
        </MtxGrid>
      </MtxGrid>
    </MtxGrid>
  );
};
